import { useQuery } from "@tanstack/react-query";
import { getBlogTagById } from "../../api/apiBlogTags";

/**
 * Hook لجلب وسام مدونة واحد
 * @param {number|string} id - Blog Tag ID
 */
export function useGetBlogTag(id) {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ["blog-tag", id],
        queryFn: () => getBlogTagById(id),
        enabled: !!id,
        retry: false,
    });

    const tag = data?.data || null;

    return { isLoading, error, tag, refetch };
}
